import React, { Component } from "react";
import { connect } from "react-redux";
import { each } from "lodash";

// Components
import PromoItem from "./PromoItem";

// CSS
import "../../css/promos.css";

class Promos extends Component {
	render() {
		let promos = [];

		if (this.props.promos) {
			each(this.props.promos, (promo, i) => {
				promos.push(<PromoItem key={i} promo={promo} />);
			});
		}

		return <div className="body_container promo_container">{promos}</div>;
	}
}

function mapStateToProps(state) {
	return {
		promos: state.siteInfo.promos
	};
}

export default connect(mapStateToProps)(Promos);



// WEBPACK FOOTER //
// ./src/components/home/Promos.js